import React from 'react';
import { Global, css } from '@emotion/react';
import { getBackgroundColor } from '../utils/getBackgroundColor';
import { getResponsiveType } from '../utils/getResponsiveType';
import { colors } from './tokens';

export const GlobalStyle = () => (
  <Global
    styles={css`
      *,
      *::before,
      *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        /* border: 0; */
      }

      *:focus-visible {
        outline: 4px solid ${colors.brandOne50};
      }

      html,
      body {
        height: 100%;
        max-width: 100vw;
        /* overflow-x: hidden; */
      }

      body {
        -webkit-font-smoothing: antialiased;
      }

      img,
      picture,
      video,
      canvas,
      svg {
        display: block;
        max-width: 100%;
      }

      input,
      button,
      textarea,
      select {
        font: inherit;
      }

      p,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        overflow-wrap: break-word;
      }

      #root,
      #__next {
        isolation: isolate;
      }

      ul,
      ol {
        list-style: none;
      }

      a {
        color: currentColor;
      }

      a[href^='tel:'] {
        text-decoration: none;
      }

      address {
        font-style: normal;
      }

      button {
        cursor: pointer;
        background: none;
        color: currentColor;
        border: 0;
      }

      iframe,
      input {
        border: 0;
      }

      // Selection

      ::selection {
      }

      // Body

      body {
        ${getResponsiveType('bodyMedium')}
        ${getBackgroundColor('neutralWhite')}
        min-height: 100vh;
        width: 100%;
        min-width: 320px;
      }

      // One trust render fix

      #ot-sdk-btn-floating .ot-floating-button__back svg {
        display: inline-block;
      }

      // hide recaptcha

      .grecaptcha-badge {
        visibility: hidden;
      }
    `}
  />
);

export default GlobalStyle;
